import { render, staticRenderFns } from "./SecondaryPending.vue?vue&type=template&id=6be796b8&scoped=true"
import script from "./SecondaryPending.vue?vue&type=script&lang=js"
export * from "./SecondaryPending.vue?vue&type=script&lang=js"
import style0 from "./SecondaryPending.vue?vue&type=style&index=0&id=6be796b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be796b8",
  null
  
)

export default component.exports